import axios from "axios";

const apiBaseUrl =
  process.env.REACT_APP_API_URL || "http://localhost:8000/api";

export const api = axios.create({
  baseURL: apiBaseUrl,
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
}

